import { Component } from 'react'
import PropTypes from 'prop-types'

class ProgressManager extends Component {
    constructor(props) {
        super(props)

        // Expose the commands to the dev console
        window.updateProgress = this.updateProgress
    }

    shouldComponentUpdate() {
        return false
    }

    // Update the progress bar
    updateProgress = (serverName, value, message) => {
        try {
            // If servername is missing, then this is
            // a message for all servers
            if (serverName == null || serverName === '') {
                this.props.setProgressMessage(message)

                // Otherwise we are updating the progress for a single server
            } else {
                const progress = {
                    value,
                    message,
                    percent: value !== undefined && value !== null ? value * 100 : -1,
                }
                this.props.saveProgress(serverName, progress)
            }
        } catch (error) {
            console.info(`Encountered error while running updateProgress: ${error.message}`)
        }
    }

    render() {
        return null
    }
}

ProgressManager.propTypes = {
    saveProgress: PropTypes.func,
    setProgressMessage: PropTypes.func,
}

export default ProgressManager



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/ProgressManager/component.js